/**
 * @see https://woocommerce.github.io/woocommerce-rest-api-docs/?shell#list-all-products
 */

import $ from 'jquery';

const WC_QUERY_ARGS = {
  // consumer_key : "ck_51b1e7d6850f254277e6471643bad962fbb1bd13",
  // consumer_secret : "cs_2c9418e7748cbcce3e2a3e0784d472b93bc79825",
  consumer_key : "ck_250383a74e2c4b8dea88b1f7f858ba65dab590c6",
  consumer_secret : "cs_141c52c2bb4af7dd144eea85c6dc577fce35aae6",
}
class WooComm {
    constructor() {

        this.EVENTS = [
            {
                eventHandler : "found_variation",
                element : "form.variations_form.cart",
                function : this.addSampleRequestHiddenField
            },
            {
              eventHandler: "click",
              element: ".js-increase",
              function: this.quantityIncrease
            },
            {
              eventHandler: "click",
              element: '.js-decrease',
              function: this.quantityDecrease
            },
            {
              eventHandler: "load change",
              element: ".qty",
              function: this.watchQuantityChange
            },
            {
              eventHandler: 'change',
              element: '#domestic_shipping_method',
              function: () => {
                jQuery(document.body).trigger('update_checkout')
              }
            }
        ];             
    }


    runEvents() {
        this.EVENTS.forEach(event => {
            $(document).on(event.eventHandler, event.element, event.function);
        });
    }

    watchQuantityChange() {
      const $quantity = $(this)
      const $qtyWrapper = $('.quantity__wrapper')
      const min = parseInt($quantity.attr('min'))
      const max = parseInt($quantity.attr('max'))
      let currentVal = parseInt($quantity.val())

      if (currentVal >= max) {
        $qtyWrapper.find('.js-increase').prop('disabled')
      } else {
        $qtyWrapper.find('.js-increase').removeProp('disabled')
      }

      if (currentVal <= min) {
        $qtyWrapper.find('.js-decrease').prop('disabled')
      } else {
        $qtyWrapper.find('.js-decrease').removeProp('disabled')
      }
    }

    quantityIncrease() {
      const $qtyWrapper = $(this).parent('.quantity__wrapper')
      const $quantity = $qtyWrapper.find('.qty')
      const max = parseInt($quantity.attr('max'))
      let currentValue = parseInt($quantity.val())

      if (isNaN(max) || currentValue + 1 <= max) {
        $quantity.val(currentValue+1)
      }
    }

    quantityDecrease() {
      const $qtyWrapper = $(this).parent('.quantity__wrapper')
      const $quantity = $qtyWrapper.find('.qty')
      const min = parseInt($quantity.attr('min'))
      let currentValue = parseInt($quantity.val())

      if (isNaN(min) || currentValue - 1 >= min) {
        $quantity.val(currentValue-1)
      }  
    }

    addSampleRequestHiddenField(e, variation) {
        // console.log(variation);
    }

    static getProducts(args = {}, done)
    {
        let query = Object.assign(args, WC_QUERY_ARGS);

        // console.log(query)

        $.get('/wp-json/alphap/v1/products', query)
        // .then((query) => {
        //   console.log(query)
        //   return query
        // })
        .then(done)
        .catch(error => {throw new Error(`API ${error}.`)});
    }

    static updateCategories(query = {}, done)
    {
        $.get('/wp-json/alphap/v1/categories', query)
        .then(done)
        .catch(error => {throw new Error(`API ${error}.`)});
    }

    static getCategories(args = {}, done)
    {
       let query = Object.assign(args, WC_QUERY_ARGS, {hide_empty : true, per_page : 100});

        $.get('/wp-json/wc/v3/products/categories', query)
        .then(done)
        .catch(error => {throw new Error(`API ${error}.`)});
    }

    static getAttributes(args = {}, done)
    {

      let query = Object.assign(args, WC_QUERY_ARGS)
        $.get('/wp-json/wc/v3/products/attributes', query)
        .then(done)
        .catch(error => {throw new Error(`API ${error}.`)});
    }


    static getAttributeTerms(attributeId, params = {}, done)
    {
        let args = Object.assign(params, WC_QUERY_ARGS)
        let endpoint = `/wp-json/wc/v3/products/attributes/${attributeId}/terms`;
        let query = Object.assign({hide_empty : true, per_page : 100}, args);

        $.get(endpoint, query)
        .then((response, status, xhr) => {
          let page = 1
          let totalPages = Number(xhr.getResponseHeader('X-WP-TotalPages'))

          let formattedAttributes = []
          response.forEach(attrbiute => {
            let name = new DOMParser().parseFromString(attrbiute.name, 'text/html')
            formattedAttributes.push({
              name: name.documentElement.textContent,
              value: attrbiute.id
            })
          })

          if (totalPages > 1) {
            while (page < totalPages) {              
              $.get(endpoint, Object.assign(query, {page: ++page}))
                .then((nextPage) => {
                  nextPage.forEach(attrbiute => {
                    let name = new DOMParser().parseFromString(attrbiute.name, 'text/html')
                    formattedAttributes.push({
                      name: name.documentElement.textContent,
                      value: attrbiute.id
                    })
                  })
                })
            }

          }

          return formattedAttributes
        })
        .then(done)
        .catch(error => {throw new Error(`API ${error}.`)});
    }
}

export {WooComm};